import {makeStyles} from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import UserAvatar from "../../user-avatar/UserAvatar";
import React from "react";
import {SubscriptionType} from "./membership-fields/SubscriptionType";
import {SingleSubscriptionExpiresIn} from "./membership-fields/SingleSubscriptionExpiresIn";
import {MembershipActions} from "./MembershipActions";
import {Typography} from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
    root: {
        height: 'auto',
        flexGrow: 1,
        maxWidth: 700,
    },
    search: {
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
        [theme.breakpoints.up('md')]: {
            width: '40%'
        }
    },
    actionColumn: {
        maxWidth: 100,
        width: 100
    },
    avatarColumn: {
        maxWidth: 70,
        width: 70
    }
}));

export const MembershipDataRow = ({
                                      values: {id, user, subscriptions, ownership},
                                      organizationId,
                                      organizationUnitId,
                                      onActionCompleted
                                  }: any) => {
    return (
        <TableRow>
            <TableCell component="th" scope="row"> <UserAvatar userId={id}/> </TableCell>
            <TableCell>
                <Typography variant="body1">{user.firstName} {user.lastName}</Typography>
                <Typography variant="body2"
                            color={'textPrimary'}>{user.email}</Typography>
            </TableCell>
            <TableCell> <SubscriptionType id={id}
                                          subscriptions={subscriptions}
                                          organizationId={organizationId}
                                          organizationUnitId={organizationUnitId}
                                          onSubscriptionRemoved={onActionCompleted}/>
            </TableCell>
            <TableCell> {subscriptions.length === 1 ?
                <SingleSubscriptionExpiresIn subscription={subscriptions[0]}/> : '----'}</TableCell>
            <TableCell>
                <MembershipActions userId={id}
                                   organizationId={organizationId}
                                   organizationUnitId={organizationUnitId}
                                   isActive={user.isActive}
                                   subscriptions={subscriptions}
                                   ownershipStatus={ownership.status}
                                   onActionCompleted={onActionCompleted}/>
            </TableCell>
        </TableRow>
    )
};
